module.exports = __webpack_public_path__ + "img/info-circle-black.9feb8961.svg";